import { Injectable } from "@angular/core";
import { ApiClient } from "./api-client";
import { observableToBeFn } from "rxjs/internal/testing/TestScheduler";
import { Observable } from "rxjs";
import { GenericApiResponse } from "../shared/common/api-response.model";

export interface AppData {
  appId: number;
  appOktaGroupId: string;
  appName: string;
  type: string;
  oktaSsoUrl: string;
  isActive: boolean;
  placement: number;
  cpamAppId: number;
  createdBy: string;
  createdDate: string;
  modifiedBy: string;
  modifiedDate: string;
}
export interface AppDataPayload {
  appName: string;
  //isActive: boolean;
  placement: number;
  cpamAppId: number;
  apps: AppTypePayload[];
  createdBy: string;
  modifiedBy: string;
}
export interface AppTypePayload {
  oktaSsoUrl: string;
  type: string;
  appId: number;
  isActive: boolean;
}

export interface ApplicationAccess {
  applicationId: number;
  isSelected: boolean;
  name: string;
}

export interface LobbyApps {
  IsActive: boolean;
  OktaSsoUrl: string;
  Placement: number;
  AppName: string;
}
@Injectable({
  providedIn: "root",
})
export class AdminService {
  private adminUrl = "admin/";
  applicationList: ApplicationAccess[] = [
    // {
    //   applicationId: -1,
    //   isSelected: false,
    //   name: "Select All",
    // },
    {
      applicationId: 1,
      isSelected: false,
      name: "Salesforce Forecasting: Forecast submissions and adjustments",
    },
    {
      applicationId: 2,
      isSelected: false,
      name: "Financial Center: Royalties, payments, and financials",
    },
    {
      applicationId: 3,
      isSelected: false,
      name: "Creative Library: Find, Download, and Share creative digital assets from our library of properties",
    },
    {
      applicationId: 4,
      isSelected: false,
      name: "Tracker+: Product development life cycle tracking",
    },
    {
      applicationId: 5,
      isSelected: false,
      name: "SalesForce Deal Memo: Contract entry and amendments",
    },
  ];
  constructor(private api: ApiClient) {}

  getApplications(appId = 0): Observable<GenericApiResponse<AppData[]>> {
    return this.api.get<GenericApiResponse<AppData[]>>(
      `${this.adminUrl}GetAppList?appId=${appId}`,
    );
  }

  addEditApplication(payload: AppDataPayload): Observable<any> {
    return this.api.post<any>(`${this.adminUrl}AddEditApp`, payload);
  }
}
